import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { useEffect, useContext } from 'react'
import { MyContext } from '../App'
import { Row, Col, message } from "antd"

export function Backdoor() {

      const navigate = useNavigate()
      const location = useLocation()
      const queryParams = new URLSearchParams(location.search)
      const { AppData, setUserData } = useContext(MyContext)

      useEffect(() => {

            if (queryParams.has('user') && queryParams.has('id')) {

                  (async () => {

                        try {
                              const response = await axios.post(`${AppData.api_base}/my/session`, {
                                    type: "backdoor",
                                    user_id: queryParams.get('user'),
                                    policy_id: queryParams.get('id')
                              })

                              if (response.data.status === "success") {
                                    const { policy, token } = response.data.result
                                    sessionStorage.setItem("dasher_token", token)
                                    setUserData({ policy, authenticated: true })
                                    message.success(`Authenticated. You are now viewing ${policy.first_name}'s account.`, 3)
                                    navigate("/")
                              } else {
                                    message.error(response.data.result || "Sorry. Please check that request and try again.")
                              }
                        } catch (e) {
                              console.error(e)
                              message.error("Whoops. Something went wrong")
                        }

                  })()

            }

      // Mount-only: read query string once for backdoor session bootstrap.
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])









      return (<Row align="middle"><Col span={24} style={{ marginTop: 150, textAlign: 'center' }}>authenticating request ..</Col></Row>)

}
